import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import './assets/layout/css/index.css';
import './assets/layout/css/App.scss';
import App from './app';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
